import { action } from "./actionCreator";

export const PRESENCE_GET_DETAILS_DAY = "presence/GET_DETAILS_DAY";
export const PRESENCE_SET_DETAILS_DAY = "presence/SET_DETAILS_DAY";

export const PRESENCE_UPDATE_ATTENDANCE_DETAILS_DAY = "presence/UPDATE_ATTENDANCE_DETAILS_DAY";
export const PRESENCE_SET_ATTENDANCE_UPDATED_DETAILS_DAY = "presence/SET_ATTENDANCE_UPDATED_DETAILS_DAY";
export const PRESENCE_SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_DAY = "presence/SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_DAY";
export const PRESENCE_RESET_ATTENDANCE_ERRORS_DETAILS_DAY = "presence/RESET_ATTENDANCE_ERRORS_DETAILS_DAY";

export const PRESENCE_UPDATE_MEAL_PACKAGE_DETAILS_DAY = "presence/UPDATE_MEAL_PACKAGE_DETAILS_DAY";
export const PRESENCE_SET_MEAL_PACKAGE_UPDATED_DETAILS_DAY = "presence/SET_MEAL_PACKAGE_UPDATED_DETAILS_DAY";
export const PRESENCE_SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_DAY =
  "presence/SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_DAY";
export const PRESENCE_RESET_MEAL_PACKAGE_ERRORS_DETAILS_DAY = "presence/RESET_MEAL_PACKAGE_ERRORS_DETAILS_DAY";

export const PRESENCE_UPDATE_TRIP_DETAILS_DAY = "presence/UPDATE_TRIP_DETAILS_DAY";
export const PRESENCE_SET_TRIP_UPDATED_DETAILS_DAY = "presence/SET_TRIP_UPDATED_DETAILS_DAY";
export const PRESENCE_SET_TRIP_UPDATE_ERRORS_DETAILS_DAY = "presence/SET_TRIP_UPDATE_ERRORS_DETAILS_DAY";
export const PRESENCE_RESET_TRIP_ERRORS_DETAILS_DAY = "presence/RESET_TRIP_ERRORS_DETAILS_DAY";

export const getPresenceDetailsDay = payload => {
  return action(PRESENCE_GET_DETAILS_DAY, { payload });
};

export const updatePresenceAttendance = payload => {
  return action(PRESENCE_UPDATE_ATTENDANCE_DETAILS_DAY, { payload });
};

export const resetPresenceAttendance = () => {
  return action(PRESENCE_RESET_ATTENDANCE_ERRORS_DETAILS_DAY, {});
};

export const updatePresenceMealPackage = payload => {
  return action(PRESENCE_UPDATE_MEAL_PACKAGE_DETAILS_DAY, { payload });
};

export const resetPresenceMealPackage = () => {
  return action(PRESENCE_RESET_MEAL_PACKAGE_ERRORS_DETAILS_DAY, {});
};

export const updatePresenceTrip = payload => {
  return action(PRESENCE_UPDATE_TRIP_DETAILS_DAY, { payload });
};

export const resetPresenceTrip = () => {
  return action(PRESENCE_RESET_TRIP_ERRORS_DETAILS_DAY, {});
};



// WEBPACK FOOTER //
// src/modules/presence/actions/presenceDetailsDay.js